export const exportResultsToCSV = (queryResults) => {
  if (queryResults.length === 0) {
    alert("No results to export");
    return;
  }
  
  const headers = [
    "Time", 
    "Event Name", 
    "Source", 
    "User", 
    "Resource ID", 
    "IP Address"
  ];
  
  const rows = queryResults.map(event => [
    `"${formatTimestamp(event.eventTime)}"`,
    `"${event.eventName?.replace(/"/g, '""') || ''}"`,
    `"${event.eventSource?.replace(/"/g, '""') || ''}"`,
    `"${event.username?.replace(/"/g, '""') || ''}"`,
    `"${event.resourceName?.replace(/"/g, '""') || ''}"`,
    `"${event.sourceIpAddress?.replace(/"/g, '""') || ''}"`,
  ]);
  
  const csvContent = [
    headers.join(","),
    ...rows.map(row => row.join(","))
  ].join("\n");
  
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `event-results-${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString();
};